<template>
  <BreadCrumb PageTitle="Chat" />
  <ChatContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../template-components/Common/BreadCrumb.vue";
import ChatContent from "../template-components/Chat/ChatContent.vue";

export default defineComponent({
  name: "ChatPage",
  components: {
    BreadCrumb,
    ChatContent,
  },
});
</script>